/**
 * Opens an external URL in the appropriate way for the platform
 * - iOS/Android PWA/App: Uses location.href to let the OS handle the URL
 * - Browser: Uses window.open to open in new tab
 */
export const openExternalUrl = (url) => {
  // Detect mobile platforms
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  // Detect standalone mode (installed as app/PWA)
  const isStandalone = window.navigator.standalone ||
    window.matchMedia('(display-mode: standalone)').matches;

  if ((isIOS || isAndroid) && isStandalone) {
    // For mobile apps, use location.href to let the OS handle the URL
    window.location.href = url;
  } else {
    // For regular browsers, open in new tab
    window.open(url, '_blank');
  }
};
